export const GET_CONTACT_START = 'GET_CONTACT_START';

export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';

export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE';
